import { useCallback } from "react";
import { useBoundStore, usePersistBoundStore } from "../zustand/Store";
import { downloadManager } from "./DownloadManager";
import { deleteEpaperEditionFolder, deleteEpaperFolder } from "../deleteEpaperFolder";
import { Magazine } from "../Datatypes";

export const useHandleDeleteMagazine = () => {
  const updateCurrentMagazine = useBoundStore((state) => state.updateCurrentMagazine);
  const deleteStoredMagazineByMagazine = usePersistBoundStore((state) => state.deleteStoredMagazineByMagazine);
  const getStoredMagazineByDate = usePersistBoundStore((state) => state.getStoredMagazineByDate);

  return useCallback(async (magazine: Magazine, onDeleteSuccess: (deletedMagazine: Magazine) => void) => {
    try {
      downloadManager.cancelDownloadByMagazine(magazine);
      updateCurrentMagazine(null);
      await deleteEpaperEditionFolder(magazine.date, magazine.edition);
      deleteStoredMagazineByMagazine(magazine);

      const stored = getStoredMagazineByDate(magazine.date);
      if (!stored || stored.length === 0) {
        await deleteEpaperFolder(magazine.date);
      }

      // Notify the parent component of successful deletion
      onDeleteSuccess(magazine);
    } catch (error) {
      console.error("Error deleting magazine:", error);
    }
  }, [updateCurrentMagazine, deleteStoredMagazineByMagazine, getStoredMagazineByDate]);
};